import { render, staticRenderFns } from "./versionDiff.vue?vue&type=template&id=2aacf2da&scoped=true&"
import script from "./versionDiff.vue?vue&type=script&lang=js&"
export * from "./versionDiff.vue?vue&type=script&lang=js&"
import style0 from "./versionDiff.vue?vue&type=style&index=0&id=2aacf2da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aacf2da",
  null
  
)

export default component.exports